import { library } from '@fortawesome/fontawesome-svg-core';

// Free Solid Icons
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBars,
  faBell,
  faCalendarAlt,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faClose,
  faCog,
  faCreditCard,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisVertical,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faGear,
  faHome,
  faHouse,
  faInfoCircle,
  faLink,
  faLock,
  faMinus,
  faPlus,
  faQuestionCircle,
  faRefresh,
  faRightFromBracket,
  faSearch,
  faShieldAlt,
  faSignOutAlt,
  faTasks,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUniversity,
  faUpload,
  faUser,
  faHandHoldingDollar,
} from '@fortawesome/free-solid-svg-icons';

// Free Regular Icons
import {
  faBell as farBell,
  faCalendarAlt as farCalendarAlt,
  faCheckCircle as farCheckCircle,
  faCreditCard as farCreditCard,
  faEye as farEye,
  faEyeSlash as farEyeSlash,
  faFile as farFile,
  faTimesCircle as farTimesCircle,
  faUser as farUser,
} from '@fortawesome/free-regular-svg-icons';

// Register all icons with the library
export function registerFontAwesomeIcons() {
  library.add(
    // Solid icons
    faAngleUp,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faCalendarAlt,
    faCheck,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faClock,
    faClose,
    faTimes,
    faEdit,
    faExclamationTriangle,
    faExclamationCircle,
    faInfoCircle,
    faQuestionCircle,
    faShieldAlt,
    faTrashAlt,
    faTasks,
    faHome,
    faHouse,
    faUniversity,
    faLock,
    faBell,
    faDownload,
    faArrowUp,
    faArrowDown,
    faEye,
    faEyeSlash,
    faSearch,
    faPlus,
    faMinus,
    faFile,
    faLink,
    faUser,
    faUpload,
    faCog,
    faGear,
    faEnvelope,
    faSignOutAlt,
    faRightFromBracket,
    faBars,
    faEllipsisVertical,
    faCreditCard,
    faDollarSign,
    faHandHoldingDollar,
    faRefresh,
    faTimesCircle,

    // Regular icons
    farEye,
    farEyeSlash,
    farCreditCard,
    farFile,
    farUser,
    farBell,
    farCalendarAlt,
    farCheckCircle,
    farTimesCircle,
  );
}

// Export icon mapping for consistent naming
export const iconMap = {
  'angle-up': ['fas', 'angle-up'],
  'angle-down': ['fas', 'angle-down'],
  'angle-left': ['fas', 'angle-left'],
  'angle-right': ['fas', 'angle-right'],
  'arrow-left': ['fas', 'arrow-left'],
  'arrow-right': ['fas', 'arrow-right'],
  'calendar': ['fas', 'calendar-alt'],
  'check': ['fas', 'check'],
  'check-circle': ['fas', 'check-circle'],
  'chevron-left': ['fas', 'chevron-left'],
  'chevron-right': ['fas', 'chevron-right'],
  'chevron-down': ['fas', 'chevron-down'],
  'clock': ['fas', 'clock'],
  'close': ['fas', 'times'],
  'times': ['fas', 'times'],
  'edit-icon': ['fas', 'edit'],
  'error-icon': ['fas', 'exclamation-triangle'],
  'error-icon-circle': ['fas', 'exclamation-circle'],
  'warning-icon': ['fas', 'exclamation-triangle'],
  'info-circle': ['fas', 'info-circle'],
  'question-circle': ['fas', 'question-circle'],
  'shield-check': ['fas', 'shield-alt'],
  'trash-alt': ['fas', 'trash-alt'],
  'tasks': ['fas', 'tasks'],
  'real-estate-icon': ['fas', 'house'],
  'manual-account-icon': ['fas', 'hand-holding-dollar'],
  'university': ['fas', 'university'],
  'lock': ['fas', 'lock'],
  'bell': ['fas', 'bell'],
  'file-download': ['fas', 'download'],
  'file': ['fas', 'file'],
  'long-arrow-up': ['fas', 'arrow-up'],
  'long-arrow-down': ['fas', 'arrow-down'],
  'eye': ['fas', 'eye'],
  'eye-slash': ['fas', 'eye-slash'],
  'magnifying-glass': ['fas', 'search'],
  'money-check': ['fas', 'credit-card'],
  'sack-dollar': ['fas', 'dollar-sign'],
  'ellipsis-vertical': ['fas', 'ellipsis-vertical'],
  'plus': ['fas', 'plus'],
  'minus': ['fas', 'minus'],
  'link': ['fas', 'link'],
  'user-vneck': ['fas', 'user'],
  'user': ['fas', 'user'],
  'file-arrow-up': ['fas', 'upload'],
  'menu': ['fas', 'bars'],
  'search': ['fas', 'search'],
  'home': ['fas', 'home'],
  'house': ['fas', 'house'],
  'settings': ['fas', 'gear'],
  'logout': ['fas', 'right-from-bracket'],
  'gear': ['fas', 'gear'],
  'envelope': ['fas', 'envelope'],
  'right-from-bracket': ['fas', 'right-from-bracket'],
  'times-circle': ['fas', 'times-circle'],
} as const;

export type IconName = keyof typeof iconMap
